import { LocalizedText } from "../../components/LocalizedText";
import './BottomMenu.css';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import ImageButton from '../../components/Buttons/ImageButton';
import { NineSlice } from '../../components/NineSlice';
import SkillMenu from '../SkillMenu';
import { showSkills } from '../../slices/skillsSlice';
import { Inventory } from '../Inventory/Inventory';
import { hideInventory, showInventory } from '../../slices/inventorySlice';
import { useAppSelector } from '../../hooks';
import { StatMenu } from '../StatMenu/StatMenu';
import { hideStats, showStats } from '../../slices/statSlice';
import { QuestNavigation } from '../QuestNavigation/QuestNavigation';
import { SERVER_CONFIG } from '../../util/serverConfig';
import { hideSocial, showSocial } from '../../slices/panelSlice';
import { SocialMenu } from '../SocialMenu/SocialMenu';
import useTranslator from '../../hooks/translate';
import Events from '../../util/EventEmitter';
import { Rankings } from '../Rankings/Rankings';
import { MarketBoard } from '../Market/MarketBoard';

export const BottomMenu: React.FC<{}> = ({}) => {
  const t = useTranslator();
  const dispatch = useDispatch();
  const showInventoryMenu = useAppSelector((state) => state.inventory.show);
  const showSkillMenu = useAppSelector((state) => state.skills.show);
  const showStatMenu = useAppSelector((state) => state.stats.show);
  const stats = useAppSelector((state) => state.stats.stats);
  const isSocialShowing = useAppSelector((state) => state.panels.social);
  const scene = useAppSelector(state => state.scene.scene);
  const villageBack = useAppSelector(state => state.ui.villageBack);
  const fight = useAppSelector(state => state.fight.fight);
  const canOpenItemMall = [111,211,311,411,511].includes(Number(scene)) && !villageBack && !fight;

  const [showQuests, setShowQuests] = React.useState(true);
  const [showRankings, setShowRankings] = React.useState(false);
  const [showMarket, setShowMarket] = React.useState(false);
  React.useEffect(() => {
    const listener = Events.on('openPlayerMarket', () => setShowMarket(true));
    return () => Events.off(listener);
  }, []);

  const expPerLevel = SERVER_CONFIG.LEVELING.expPerLevel;
  const expForLevel = expPerLevel[stats.level];
  const expToLevel = expPerLevel[stats.level + 1];

  const percent = Math.floor(((stats.exp - expForLevel) / (expToLevel - expForLevel)) * 100);
  const isMaxLevel = stats.level >= (SERVER_CONFIG.LEVELING?.max ?? 99);

  return (
    <>
      <div className="game-hud" style={{ position: 'absolute', bottom: 1, right: 1, width: 656, height: 33 }}>
        <div style={{ position: 'relative' }}>
          <NineSlice
            url={`${process.env.REACT_APP_CDN_PATH}features/bottom-menu/2.png`}
            slice={[8, 20]}
            style={{ width: 238 - 10, height: 26 * 1.19 - 4, position: 'absolute', top: 0 }}
          />
          <div className="text-shadow" style={{ position: 'absolute', top: 4, left: 4, fontSize: 12 }}>
            {t('Level')}: {stats.level}
          </div>
          <div className="text-shadow" style={{ position: 'absolute', top: 16, left: 4, fontSize: 12 }}>
            {t('Exp')}:<LocalizedText text={isMaxLevel ? '' : ' '} />
            {!isMaxLevel && (
              <progress max={100} value={percent} title={`${stats.exp} / ${expToLevel}`} style={{ width: 195, accentColor: 'green' }} />
            )}
          </div>

          {isMaxLevel && (
            <div
              className="text-outline"
              style={{
                position: 'absolute',
                top: -4,
                width: 228,
                textAlign: 'right',
                fontFamily: 'KOMIKAK',
                fontSize: 22,
                color: 'darkgreen',
              }}><LocalizedText text={"MAX"} /></div>
          )}

          <NineSlice
            url={`${process.env.REACT_APP_CDN_PATH}features/bottom-menu/2.png`}
            slice={[8, 20]}
            style={{ width: 419 - 10, height: 26 * 1.19 - 4, position: 'absolute', top: 0, left: 238 }}
          />

          <ImageButton
            onClick={() => dispatch(showInventoryMenu ? hideInventory() : showInventory())}
            defaultImage={'features/bottom-menu/11-1.png'}
            style={{ position: 'absolute', top: 3, left: 241 }}
          />
          <ImageButton
            onClick={() => dispatch(showStatMenu ? hideStats() : showStats())}
            defaultImage={'features/bottom-menu/11-2.png'}
            style={{ position: 'absolute', top: 3, left: 292 }}
          />
          <ImageButton
            onClick={() => dispatch(showSkillMenu ? showSkills(false) : showSkills(true))}
            defaultImage={'features/bottom-menu/11-3.png'}
            style={{ position: 'absolute', top: 3, left: 343 }}
          />
          <ImageButton
            onClick={() => setShowQuests(!showQuests)}
            defaultImage={'features/bottom-menu/task.png'}
            style={{ position: 'absolute', top: 3, left: 393 }}
          />
          <ImageButton
            onClick={() => dispatch(isSocialShowing ? hideSocial() : showSocial())}
            defaultImage={'features/bottom-menu/social.png'}
            style={{ position: 'absolute', top: 3, left: 443 }}
          />
          <ImageButton
            onClick={() => setShowRankings(value => !value)}
            defaultImage={'features/bottom-menu/rank.png'}
            style={{ position: 'absolute', top: 3, left: 493 }}
            title={t('game_rank__title')}
          />
          <ImageButton
            onClick={() => setShowMarket(value => !value)}
            defaultImage={'features/bottom-menu/mart.png'}
            style={{ position: 'absolute', top: 3, left: 543 }}
            title={t('Market')}
          />
          <ImageButton
            onClick={() => Events.emit('openGoldMall')}
            defaultImage={'features/bottom-menu/shop.png'}
            title="ร้านค้าโกลด์"
            style={{ position: 'absolute', top: 3, left: 593 }}
            disabled={!canOpenItemMall}
          />
          {showQuests && (
            <QuestNavigation
              style={{ position: 'absolute', top: 0, left: 651, transform: 'translate(-100%, -100%)' }}
              onClose={() => setShowQuests(false)}
            />
          )}
        </div>
      </div>

      {showSkillMenu && <SkillMenu />}
      {showRankings && <Rankings onClose={() => setShowRankings(false)} />}
      {showMarket && <MarketBoard onClose={() => setShowMarket(false)} />}
      {showInventoryMenu && <Inventory />}
      {showStatMenu && <StatMenu />}
      <SocialMenu />
    </>
  );
};
